import {Action} from '@ngrx/store';
import {ArrayResponse} from '../../shared/models/array-response';
import {SelectedItem} from '../models/order';
import {type} from '../../shared';
import {OrderFilter} from '../models/order-filter';
import {OrderItem} from '../models/order-item';

export const orderListActionTypes = {
  TOGGLE_SEARCH: type('[orders] Toggle Search Form'),
  QUICK_SEARCH: type('[orders] Quick Search'),
  SEARCH: type('[orders] Search'),
  CHANGE_PAGE_SIZE: type('[orders] Change Page Size'),
  PAGE_TO: type('[orders] Page To'),
  ORDER_BY: type('[orders] Order By'),
  LOAD: type('[orders] Load'),
  LOAD_SUCCESS: type('[orders] Load Success'),
  LOAD_FAIL: type('[orders] Load Fail'),
  SELECT_PAGE: type('[orders] Select Page'),
  UNSELECT_PAGE: type('[orders] Unselect Page'),
  TOGGLE_SELECTION: type('[orders] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[orders] Toggle Selection Tags'),
  CLEAR: type('[orders] Clear Data'),
  CLEAR_ALL: type('[orders] Clear ALL Data'),
  PRODUCTION_LINE: type('[orders] Production Line'),
};


export class ToggleSearchOrdersAction implements Action {
  readonly type = orderListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}

export class QuickSearchOrdersAction implements Action {
  readonly type = orderListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}
export class ProductionLineAction implements Action {
  readonly type = orderListActionTypes.PRODUCTION_LINE;
  constructor(public payload?: string) {}
}

export class SearchOrdersAction implements Action {
  readonly type = orderListActionTypes.SEARCH;
  constructor(public payload?: OrderFilter | string | number) {}
}

export class ChangeOrdersPageSizeAction implements Action {
  readonly type = orderListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}

export class PageOrdersToAction implements Action {
  readonly type = orderListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}

export class OrderOrdersByAction implements Action {
  readonly type = orderListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}

export class LoadOrdersAction implements Action {
  readonly type = orderListActionTypes.LOAD;
  constructor() {}
}

export class LoadOrdersSuccessAction implements Action {
  readonly type = orderListActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ArrayResponse<OrderItem>) {}
}

export class LoadOrdersFailAction implements Action {
  readonly type = orderListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SelectOrdersPageAction implements Action {
  readonly type = orderListActionTypes.SELECT_PAGE;
  constructor() {}
}

export class UnselectOrdersPageAction implements Action {
  readonly type = orderListActionTypes.UNSELECT_PAGE;
  constructor() {}
}
export class ToggleOrdersSelectionAction implements Action {
  readonly type = orderListActionTypes.TOGGLE_SELECTION;
  constructor(public payload?: SelectedItem) {}
}
export class ClearOrdersAction implements Action {
  readonly type = orderListActionTypes.CLEAR;
  constructor() {}
}
export class ClearAllOrdersAction implements Action {
  readonly type = orderListActionTypes.CLEAR_ALL;
  constructor() {}
}
